import React from 'react';
import {
  ADMIN_DATE_PLACEHOLDER,
  displayAdminProspectEmail,
  displayAdminProspectPhone,
  adminProspectTelHref,
  formatAdminDate,
} from './adminProspectDisplay';
import {
  ProspectOwnerResponseCard,
  ProspectOwnerResponseField,
  ProspectProjectionProvenance,
  ProspectProjectionVerification,
} from './ProspectOwnerResponseShared';

export default function ProspectPrimaryContactCard({
  contact,
  language,
  t,
  busy,
  pending,
  error,
  onRequestChange,
  onConfirm,
  onCancel,
  onReload,
  hideTitle = false,
  embedded = false,
}) {
  if (!contact) {
    return (
      <ProspectOwnerResponseCard
        title={t('admin.prospection.section.primaryContact')}
        description={t('admin.prospection.primaryContact.legalOwnerNote')}
        hideTitle={hideTitle}
        embedded={embedded}
      >
        <p className="text-sm text-slate-600">{t('admin.prospection.primaryContact.empty')}</p>
      </ProspectOwnerResponseCard>
    );
  }

  const email = displayAdminProspectEmail(contact.email);
  const phone = displayAdminProspectPhone(contact.phone);
  const telHref = adminProspectTelHref(phone);
  const firstCaptured = formatAdminDate(contact.firstCapturedAt, language);
  const updatedAt = formatAdminDate(contact.updatedAt, language);

  return (
    <ProspectOwnerResponseCard
      title={t('admin.prospection.section.primaryContact')}
      description={t('admin.prospection.primaryContact.legalOwnerNote')}
      hideTitle={hideTitle}
      embedded={embedded}
      fields={
        <>
          {contact.fullName ? (
            <ProspectOwnerResponseField label={t('admin.prospection.primaryContact.fullName')}>
              {contact.fullName}
            </ProspectOwnerResponseField>
          ) : null}
          {email ? (
            <ProspectOwnerResponseField label={t('admin.prospection.primaryContact.email')}>
              <a
                href={`mailto:${email}`}
                className="font-semibold text-indigo-700 underline-offset-2 hover:underline focus:outline-none focus:ring-2 focus:ring-indigo-500"
                aria-label={t('admin.prospection.primaryContact.emailAction').replace('{email}', email)}
              >
                {email}
              </a>
            </ProspectOwnerResponseField>
          ) : null}
          {phone && telHref ? (
            <ProspectOwnerResponseField label={t('admin.prospection.primaryContact.phone')}>
              <a
                href={telHref}
                className="font-semibold text-indigo-700 underline-offset-2 hover:underline focus:outline-none focus:ring-2 focus:ring-indigo-500"
                aria-label={t('admin.prospection.primaryContact.phoneAction').replace('{phone}', phone)}
              >
                {phone}
              </a>
            </ProspectOwnerResponseField>
          ) : null}
          {firstCaptured && firstCaptured !== ADMIN_DATE_PLACEHOLDER ? (
            <ProspectOwnerResponseField label={t('admin.prospection.primaryContact.firstCapturedAt')}>
              {firstCaptured}
            </ProspectOwnerResponseField>
          ) : null}
          {updatedAt && updatedAt !== ADMIN_DATE_PLACEHOLDER ? (
            <ProspectOwnerResponseField label={t('admin.prospection.primaryContact.updatedAt')}>
              {updatedAt}
            </ProspectOwnerResponseField>
          ) : null}
          <ProspectProjectionProvenance provenance={contact.provenance} language={language} t={t} />
        </>
      }
    >
      <ProspectProjectionVerification
        section="primaryContact"
        verificationState={contact.verificationState}
        busy={busy}
        pending={pending}
        error={error}
        t={t}
        onRequestChange={onRequestChange}
        onConfirm={onConfirm}
        onCancel={onCancel}
        onReload={onReload}
      />
    </ProspectOwnerResponseCard>
  );
}
